import { useQueryClient } from 'react-query';
import useApiMutation from './useApiMutation';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

export default function useUpdateCommentMutation(commentId, options = {}, modelType, modelId) {
  const queryClient = useQueryClient();
  const key = QUERY_CACHE_KEY.comments(modelType, modelId);

  return useApiMutation('patch', `/v1/comments/${commentId}`, {
    async onMutate({ body }) {
      await queryClient.cancelQueries(key);
      const previous = queryClient.getQueryData(key);
      queryClient.setQueryData(key, (old) => ({
        ...old,
        items: old.items.map((c) => (c.id === commentId ? { ...c, comment: body } : c)),
      }));
      return { previous };
    },
    onError(err, newData, context) {
      // rollback si erreur
      queryClient.setQueryData(key, context.previous);
    },
    onSettled() {
      // on refetch pour être sûr
      queryClient.invalidateQueries(key);
    },
    ...options,
  });
}
